import React from "react";

import { tw } from "~/utils";

type LabelWithActionsProps = {
  value: React.ReactNode;
  actions?: React.ReactNode;
  error?: string;
  className?: string;
};

export const LabelWithActions = ({
  value,
  actions,
  error,
  className,
}: LabelWithActionsProps) => {
  return (
    <div
      className={tw(
        "flex h-12 w-full items-center justify-between gap-2.5 rounded-md border bg-white px-1.5",
        "focus-within:border-indigo focus-within:ring-indigo border-neutral-500 focus-within:ring-1",
        error &&
          "border-red-500 focus-within:border-red-500 focus-within:ring-red-500",
        className,
      )}
    >
      <div className="min-w-0 flex-1 truncate text-sm text-gray-900">
        {value}
      </div>

      {actions && (
        <div className="flex shrink-0 items-center gap-2">{actions}</div>
      )}
    </div>
  );
};
